export const getCurrentMonthObjects = (data: any) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const currentMonthObjects = data.filter((item: any) => {
    const date = new Date(item.startDate);
    const itemMonth = date.getMonth() + 1;
    const itemYear = date.getFullYear();
    return itemMonth === currentMonth && itemYear === currentYear;
  });
  // Check if length is 2 or greater
  return currentMonthObjects.length >= 2;
};